import {Selector, State} from '@ngxs/store';
import {OutdatedDevicesStateModel} from '@store/oudated-devices/outdated-devices.state.model';
import {itemsPerPage} from '@shared/helpers';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {DeviceService} from '@services/device/device.service';
import {IOutdatedDevice} from '@interfaces/devices';
import {NgxsDataRepository} from '@angular-ru/ngxs/repositories';
import {Payload, StateRepository} from '@angular-ru/ngxs/decorators';
import {DataActionWithoutSubscription} from '@shared/functions';
import {CookieService} from 'ngx-cookie';


@StateRepository()
@State<OutdatedDevicesStateModel>({
    name: 'OutdatedDevicesState',
    defaults: {
        currentPage: 1,
        totalDevices: 0,
        outdatedDevices: [],
        itemsPerPage: itemsPerPage[5],
        sortParam: '-id',
    }
})

@Injectable()
export class OutdatedDevicesState extends  NgxsDataRepository<OutdatedDevicesStateModel> {
    constructor(
        private deviceService: DeviceService,
        private cookie: CookieService,
        ) {
        super();
    }

    @Selector([OutdatedDevicesState])
    static getOutdatedDevices(state: OutdatedDevicesStateModel): IOutdatedDevice[] {
        return state.outdatedDevices;
    }

    @Selector([OutdatedDevicesState])
    static getTotalDevices(state: OutdatedDevicesStateModel): number {
        return state.totalDevices;
    }

    @DataActionWithoutSubscription()
    getDevicesByPage(@Payload('[Outdated devices] get devices by page') currentPage: number): Observable<any> {
        this.ctx.patchState({currentPage});
        return this.fetchOutdatedDevices();
    }

    @DataActionWithoutSubscription()
    setDevicesPerPage(@Payload('[Outdated devices] set devices count per page') count: number): Observable<any> {
        this.cookie.put('devicesPerPage', count.toString());

        this.ctx.patchState({itemsPerPage: count, currentPage: 1});
        return this.fetchOutdatedDevices();
    }

    @DataActionWithoutSubscription({cancelUncompleted: true})
    fetchOutdatedDevices(): Observable<any> {
        const state = this.ctx.getState();
        const limit = state?.itemsPerPage ?? 10;
        const skip = limit * ((state?.currentPage ?? 1) - 1);
        const order = state?.sortParam ?? null;

        return this.deviceService.getDevicesWithOutdatedApp(limit, order, skip)
            .pipe(
                tap((outdated) => {
                    this.ctx.patchState({
                        outdatedDevices: outdated.rows,
                        totalDevices: outdated.total
                    });
                })
            );
    }

    @DataActionWithoutSubscription({cancelUncompleted: true})
    sortDevices(@Payload('[Outdated devices] Sort device') param: string): void {
        this.ctx.patchState({sortParam: param});
        this.fetchOutdatedDevices();
    }
}
